import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=efc07cc2&scoped=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"
import style0 from "./Company.vue?vue&type=style&index=0&id=efc07cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc07cc2",
  null
  
)

export default component.exports